// Landing Page Area Constants
export const PAGE_SIDE_PADDING = 40;
export const LANDING_HEADER_INNER_HEIGHT = 50;
export const PAGE_MIN_WIDTH = 768;

// Module Area Constants
export const HEADER_HEIGHT = 48;
export const HEADER_SIDE_PADDING = 8;
export const VIEW_BAR_HEIGHT = 45;
export const NAV_BAR_HEIGHT = 90;
export const PROPERTY_PANEL_WIDTH = 280;
export const PROPERTY_PANEL_POPOVER_WIDTH = PROPERTY_PANEL_WIDTH;
export const PROPERTY_PANEL_INLINE_LABEL_WIDTH = 60;
export const PROP_PANEL_PADDING = 15;
export const PROP_PANEL_GUTTER = 0;
export const PROPERTY_PANEL_SECTION_CLASSNAME = "property-panel-section";
export const SIDEBAR_COLLAPSED_WIDTH = 54;
export const SIDEBAR_PANEL_WIDTH = PROPERTY_PANEL_WIDTH;
export const PANEL_HEADER_HEIGHT = 38;
export const DEFAULT_INPUT_HEIGHT = 28;
export const DEFAULT_ICON_SIZE = 16;
export const TOOLBAR_ICON_SIZE = DEFAULT_ICON_SIZE;
export const BUTTON_HEIGHT = 28;
export const BUTTON_SMALL_HEIGHT = 24;

// Typography
export const FONT_WEIGHT_NORMAL = 400;
export const FONT_WEIGHT_MEDIUM = 500;
export const FONT_WEIGHT_SEMI_BOLD = 600;
export const FONT_WEIGHT_BOLD = 700;
